import { CaretDownSharp, CaretForwardSharp } from 'react-ionicons';

const TierHeader = ({ tierTitle, onClick, isVisible = false }: { tierTitle: string, onClick: () => void, isVisible: boolean }) => {
  return (
    <div className='d-flex align-items-center justify-content-between cursor-pointer' onClick={onClick}>
      <div className='position-relative pd-l-20'>
        <div className='observation-statement-img-wrap'>
          <span className='visible-in-print-view'><CaretDownSharp color={'#000000'} height="15px" width="15px" /></span>
          <span className='print-element-hide'>
            {isVisible ? <CaretDownSharp color={'#000000'} height="15px" width="15px" /> : <CaretForwardSharp color={'#000000'} height="15px" width="15px" />}
          </span>
        </div>
        <div className='fs-12 fw-semibold text-black'>{tierTitle}</div>
      </div>
    </div>
  );
};

export default TierHeader;
